/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DonationAnswersDto
 */
export interface DonationAnswersDto {
    /**
     * 
     * @type {boolean}
     * @memberof DonationAnswersDto
     */
    hasGratuitousDispositions: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof DonationAnswersDto
     */
    gratuitousDispositionsDetails: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DonationAnswersDto
     */
    hasOtherDispositions: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof DonationAnswersDto
     */
    otherDispositionsDetails: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DonationAnswersDto
     */
    hasAssetSettlement: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof DonationAnswersDto
     */
    assetSettlementDetails: string | null;
}

/**
 * Check if a given object implements the DonationAnswersDto interface.
 */
export function instanceOfDonationAnswersDto(value: object): value is DonationAnswersDto {
    if (!('hasGratuitousDispositions' in value) || value['hasGratuitousDispositions'] === undefined) return false;
    if (!('gratuitousDispositionsDetails' in value) || value['gratuitousDispositionsDetails'] === undefined) return false;
    if (!('hasOtherDispositions' in value) || value['hasOtherDispositions'] === undefined) return false;
    if (!('otherDispositionsDetails' in value) || value['otherDispositionsDetails'] === undefined) return false;
    if (!('hasAssetSettlement' in value) || value['hasAssetSettlement'] === undefined) return false;
    if (!('assetSettlementDetails' in value) || value['assetSettlementDetails'] === undefined) return false;
    return true;
}

export function DonationAnswersDtoFromJSON(json: any): DonationAnswersDto {
    return DonationAnswersDtoFromJSONTyped(json, false);
}

export function DonationAnswersDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DonationAnswersDto {
    if (json == null) {
        return json;
    }
    return {
        
        'hasGratuitousDispositions': json['hasGratuitousDispositions'],
        'gratuitousDispositionsDetails': json['gratuitousDispositionsDetails'],
        'hasOtherDispositions': json['hasOtherDispositions'],
        'otherDispositionsDetails': json['otherDispositionsDetails'],
        'hasAssetSettlement': json['hasAssetSettlement'],
        'assetSettlementDetails': json['assetSettlementDetails'],
    };
}

export function DonationAnswersDtoToJSON(json: any): DonationAnswersDto {
    return DonationAnswersDtoToJSONTyped(json, false);
}

export function DonationAnswersDtoToJSONTyped(value?: DonationAnswersDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'hasGratuitousDispositions': value['hasGratuitousDispositions'],
        'gratuitousDispositionsDetails': value['gratuitousDispositionsDetails'],
        'hasOtherDispositions': value['hasOtherDispositions'],
        'otherDispositionsDetails': value['otherDispositionsDetails'],
        'hasAssetSettlement': value['hasAssetSettlement'],
        'assetSettlementDetails': value['assetSettlementDetails'],
    };
}

